export function escapeHtmlAttributes(attrStr) {
    if (!attrStr) {
        return attrStr;
    }

    return attrStr.replace(/"/g, '&quot;')
        .replace(/'/g, "&#x27;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
}

export default escapeHtmlAttributes;
